import type { InsightsTradingCompany } from "@shared-core/data/api-types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../primitives/select";

// The Insights page header's Trading company control. "Group" is the default
// (the trading companies summed); each option is one company's books, by name.
// The page keeps the choice in the URL; this component only draws it.

// Radix Select cannot hold an empty value, so Group is a sentinel that is never
// a trading company code (codes are three capital letters).
const GROUP = "group";

export function TradingCompanySelect({
  tradingCompanies,
  value,
  onChange,
}: {
  tradingCompanies: InsightsTradingCompany[];
  /** The chosen company's code; undefined is the group. */
  value: string | undefined;
  onChange: (tradingCompany: string | undefined) => void;
}) {
  // One trading company has nothing to choose between, so the control is not
  // drawn rather than offering a lone option.
  if (tradingCompanies.length < 2) return null;

  return (
    <div className="flex items-center gap-2">
      <span id="insights-trading-company-label" className="text-sm">
        Trading company
      </span>
      <Select
        value={value ?? GROUP}
        onValueChange={(next) => onChange(next === GROUP ? undefined : next)}
      >
        <SelectTrigger
          size="sm"
          className="w-40"
          aria-labelledby="insights-trading-company-label"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={GROUP}>Group</SelectItem>
          {tradingCompanies.map((company) => (
            <SelectItem key={company.code} value={company.code}>
              {company.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
